import { Component, HostListener, Renderer2 } from '@angular/core';
import * as msal from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import {HttpErrorResponse } from '@angular/common/http';
import { RegisterUser } from '../../models/user-center.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { HelperMethods } from '../common/helper-methods.service';
import { ToastrService } from 'ngx-toastr';
import { LogInProvider } from '../../const';
import { SharedService } from '../../shared/services/shared.service';
import { ThemeService } from '../../shared/services/theme.service';

declare const google: any; // 👈 this fixes "google is not defined"

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent {
  LogInProvider = LogInProvider;
  showPassword = false;
  currentLoginProvider = LogInProvider.Deesha;
  thirdPartyLogin = false;
  loginForm: FormGroup = new FormGroup({
    emailId: new FormControl('', [
      Validators.required,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ]),
    password: new FormControl('', [
      Validators.required,
      this.helperMethods.uppercaseValidator(),
      this.helperMethods.lowercaseValidator(),
      this.helperMethods.numberValidator(),
      this.helperMethods.SpecialCharValidator(),
      Validators.minLength(6),
    ])
  });
  constructor(
    private msalService: MsalService,
    private loginService: LoginService,
    private router: Router,
    private helperMethods: HelperMethods,
    private toasterService: ToastrService,
    private sharedService: SharedService,
    private themeService: ThemeService,
    private renderer: Renderer2
  ) 
  { 
    //this.msalService.initialize()
  }

  ngOnInit() {
    if(this.sharedService.getLoginToken(true)!=null)
    {
      this.goToLandingPage()
      return;
    }

    this.sharedService.setHoldingState(null,null);
    // @ts-ignore
    // scope: 'openid email profile',
    this.tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: '358990366454-vo59vo9f0ae6j37gedpn3vod0mnm8r3s.apps.googleusercontent.com',
      scope: 'openid email profile',
      callback: (tokenResponse: any) => {
         if (tokenResponse.error) {
          console.error('Token error:', tokenResponse);
          this.toasterService.error("Error occurred with Google login provider: ", "Error");
        
          return;
        }

        fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        })
        .then(res => res.json())
        .then(data => {
          if(data.email_verified==false)
          {
            this.toasterService.success('Unable to verify email', 'Error');
          }
          else
          { 
            let userDetails: RegisterUser = {
              name: data.name,
              emailId: data.email,
              password: tokenResponse.access_token,
              loginProvider: this.currentLoginProvider
            }
            this.authenticateUser(userDetails);
          }
        })
        .catch(err => 
          console.error('Error fetching user info:', err)
        );
      },
    });

    this.msalService.initialize();
    this.updateInfo(); 
  }
  
  ngAfterViewInit() {
    this.updateInfo(); 
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateInfo(); 
  }

  updateInfo() {
    if (window.innerWidth <= 767) {
      const targetElement = document.getElementById('targetSection');
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  
  login(provider: LogInProvider = LogInProvider.Deesha){
    
    sessionStorage.clear();
    this.currentLoginProvider = provider;

    if(provider==LogInProvider.Deesha){
      this.thirdPartyLogin = false;
      let userDetails: RegisterUser = {
        emailId: this.loginForm.controls['emailId'].value,
        password: this.loginForm.controls['password'].value,
        loginProvider: this.currentLoginProvider
      }
      this.authenticateUser(userDetails);
      return;
    }

    this.thirdPartyLogin = true;
    if(provider==LogInProvider.M365){
      
      this.msalService.loginPopup({
        scopes: ['https://analysis.windows.net/powerbi/api/Report.Read.All']
      }).subscribe((response: msal.AuthenticationResult)=>{
        this.msalService.instance.setActiveAccount(response.account);
        let userDetails: RegisterUser = {
          name: response.account.name,
          emailId: response.account.username,
          loginProvider: this.currentLoginProvider
        }
        this.authenticateUser(userDetails);
      });
    }
    else{
        //this.toasterService.error("Unhandles login provider: " + LogInProvider[provider], "Error");
        // Trigger the login prompt manually
        // @ts-ignore
        // google.accounts.id.prompt(); 
        // // Opens the one-tap or popup login
         this.tokenClient.requestAccessToken({
          hint: this.loginForm.controls['emailId'].value
         });

    }
  }
  
  revokeToken(accessToken:string) {
    fetch(`https://oauth2.googleapis.com/revoke?token=${accessToken}`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then(() => {
      console.log("Token revoked");
      // Now clear app state
    })
    .catch((err) => console.error("Error revoking token", err));
  }

  authenticateUser(userDetails: RegisterUser){
    sessionStorage.removeItem('client_account');
    sessionStorage.removeItem('client_reference');
    sessionStorage.removeItem('package_of_client_account');
    sessionStorage.removeItem('my_ref_school_id');
    sessionStorage.removeItem('school_id');
    this.sharedService.setHoldingState(null,null);
    
    return this.loginService.validateUser(userDetails).subscribe(async (response: any)=>
    {
      if(this.currentLoginProvider==LogInProvider.Google){
        if(userDetails.password)
          this.revokeToken(userDetails.password)
      }

      if(response.token){
        await this.sharedService.login(response.token);
        const userProfile = this.sharedService.getUserProfile()!;
        const theme = userProfile?.themeName??'deesha';
        
        await this.themeService.toggleTheme(this.renderer,theme);
        this.goToLandingPage();
       // this.sharedService.triggerThemeChange(theme)
      //  setTimeout(() => {
      //   //this.goToLandingPage();
      //  }, 800);
      }
      else{
        this.sharedService.logout();
      }
      
    },(error: HttpErrorResponse)=>{
      
      if(error.status == 401 && this.thirdPartyLogin){
        this.sharedService.preserveContrastModeAndClearLocalStorage();
        sessionStorage.clear();

        this.toasterService.error(error.error, "Error")
        setTimeout(()=>{
          if(this.currentLoginProvider==LogInProvider.Google){
            if(userDetails.password)
              this.revokeToken(userDetails.password)
          }
          else if(this.currentLoginProvider==LogInProvider.M365){
            this.msalService.logoutRedirect().subscribe(()=>{
              this.toasterService.success('Logged out of Microsoft', 'Success');
            });
          }
        },3000)
      }
      else{
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      }
    });
  }

  goToLandingPage(){

    this.router.navigate(['/ticketManagement']);
  }
}
